import Vue from 'vue'
import axios from 'axios'
import AxiosConfig from './axios-config'
import qs from 'qs'
import router from '@/router'
import wx from 'weixin-js-sdk'
import {LocationHref} from './common'

var AxiosSND = axios.create(AxiosConfig)
AxiosSND.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token') || ''
        const user_id = localStorage.getItem('user_id') || ''
        config.headers['x-token'] = token
        config.headers['Authorization'] = token
        config.headers['x-user-id'] = user_id
        return config
    },
    error => {
        return error
    }
)

// 全局配置，携带cookie信息
AxiosSND.defaults.withCredentials = false
//把封装的axios作为vue的插件使用
Object.defineProperties(Vue.prototype, {
    axios: {
        get() {
            return AxiosSND
        }
    },

    $http: {
        get() {
            return AxiosSND
        }
    }
})
export default {
    api: 'https://byh-api.dr-gobroad.com',
    host: 'https://care-yyh.com',

    home: '/course-phase/api/homepage',
    banner: '/course-phase/api/banner/list',
    category: '/course-phase/api/category/list',
    video_info: '/course-phase/api/video/info',
    comment: '/course-phase/api/comment',
    pointLikeComment: '/course-phase/api/comment/toggle/like/',
    footprint: '/user-phase/api/footprint/record',
    amount_rule: '/user-phase/api/point/rules',
    share: '/course-phase/api/share',
    progress: '/course-phase/api/course/record',
    search: '/course-phase/api/search',
    history_search: '/course-phase/api/search_words',
    content_recommend: '/course-phase/api/recommend_v2',
    content_recommend_type: '/course-phase/api/recommend_v2/type',
    wechat_share: '/wechat-phase/jsSdk',
    shareFootPrintUrl: '/user-phase/api/share/record',
    exposureFootPrintUrl: '/user-phase/api/exposure/record',
    pvPrintUrl: '/user-phase/api/browsing/record',
    corecord: '/user-phase/api/corecord',
    user: {
        login: '/user-phase/oauth/sms/login',
        send_verify: '/user-phase/oauth/sms/verify-code',
        check_verify: '/user-phase/oauth/sms/verify-code/check',
        update_tel: '/user-phase/api/change/mobile',
        position: '/user-phase/api/position',
        city: '/user-phase/api/city',
        office: '/user-phase/api/office',
        reg_complete:"/user-phase/api/change/regComplete",
        office_search: '/user-phase/api/office/search',
        hospital: '/user-phase/api/hospitalNew',
        hospital_search: '/user-phase/api/hospitalNew/search',
        add_info: '/user-phase/api/user/info',
        user_info: '/user-phase/oauth/userinfo',
        openid_login: '/user-phase/oauth/openid/login',
        union_login: '/user-phase/oauth/unionid/login',
        uuid_login: '/user-phase/oauth/uuid/login',
        history: '/user-phase/api/footprint/list',
        favorite: '/user-phase/api/favorite/list',
        appointment: '/user-phase/api/appointment',
        point: '/user-phase/api/point/list',
        apply_diagnose: '/activity-phase/api/diagnose/apply/',
        apply_clinic: '/activity-phase/api/clinic/apply/',
        apply_group: '/activity-phase/api/group/apply/',
        apply_community: '/activity-phase/api/community/apply/',
        tags: '/course-phase/api/tags'
    },

    course: {
        list: '/course-phase/api/course/list',
        detail: '/course-phase/api/course',

        category: '/course-phase/api/category/list?type=1',

        comment: {
            store: '/course-phase/api/comment',
            list: '/course-phase/api/comment'
        },
        point_like: '/course-phase/api/course/toggle/like/1',
        favorite: '/course-phase/api/course/toggle/favorite/',
        pdf_download: '/course-phase/api/course/download/1',
        column: {
            detail: '/course-phase/api/course',
            pdf_download: '/course-phase/api/courseItem/download/1'
        },
        ad_click: '/course-phase/api/screen_advert/',
        hot_click: '/course-phase/api/hot_words/',
        hot_search: '/course-phase/api/search_words/hot',
        del_hot_word: '/course-phase/api/search_words/user'
    },
    short_video: {
        category: '/course-phase/api/category/list?type=3',
        list: '/course-phase/api/video/list',
        detail: '/course-phase/api/video/detail',
        point_like: '/course-phase/api/video/toggle/like/',
        favorite: '/course-phase/api/video/toggle/favorite/',
        comment: {
            store: '/course-phase/api/video/comment',
            list: '/course-phase/api/video/comment/list/1?limit=3&page=1'
        }
    },
    article: {
        list: '/course-phase/api/article/list',
        detail: '/course-phase/api/article/detail',
        favorite: '/course-phase/api/article/toggle/favorite',
        comment: {
            store: '/course-phase/api/article/comment',
            list: '/course-phase/api/article/comment/list/1'
        }
    },
    live: {
        home: '/live-phase/api/homepage',
        reBack: '/live-phase/api/live/backs',
        detail: '/live-phase/api/live',
        subscribeItem: '/live-phase/api/liveItems/subscribe/',
        expert_record: '/live-phase/api/liveItems/expert/',
        view_count: '/live-phase/api/live/view',
        favorite: '/live-phase/api/liveItems/favorite/',
        appointment: '/live-phase/api/liveItems/appointment/',
        record: '/live-phase/api/live/record',
        check_password: '/live-phase/api/liveItems/password',
        column: {
            list: '/live-phase/api/lives',
            detail: '/live-phase/api/live/'
        }
    },

    //近期活动
    activity: {
        list: '/activity-phase/api/activity',
        detail: '/activity-phase/api/activity/',
        favorite: '/activity-phase/api/activity/favorite/',
        like: '/activity-phase/api/activity/like/'
    },

    //近期活动
    guide: {
        list: '/activity-phase/api/guide',
        detail: '/activity-phase/api/guide/',
        favorite: '/activity-phase/api/guide/favorite/',
        like: '/activity-phase/api/guide/like/'
    },

    //近期活动
    clinic: {
        list: '/activity-phase/api/clinic',
        detail: '/activity-phase/api/clinic/',
        favorite: '/activity-phase/api/clinic/favorite/',
        like: '/activity-phase/api/clinic/like/'
    },

    //公益行动
    community: {
        list: '/activity-phase/api/community',
        detail: '/activity-phase/api/community/',
        favorite: '/activity-phase/api/community/favorite/',
        like: '/activity-phase/api/community/like/',
        what_we_do: '/community/api/content',
        share_info: '/community/api/baseconfig/share/'
    },

    //诊断送检
    diagnose: {
        list: '/activity-phase/api/diagnose',
        detail: '/activity-phase/api/diagnose/',
        favorite: '/activity-phase/api/diagnose/favorite/',
        like: '/activity-phase/api/diagnose/like/'
    },

    //互助圈
    comrade: {
        list: '/activity-phase/api/comrade',
        group: '/activity-phase/api/group',
        detail: '/activity-phase/api/comrade/',
        favorite: '/activity-phase/api/comrade/favorite/',
        like: '/activity-phase/api/comrade/like/'
    },

    knowledge: {
        list: '/activity-phase/api/knowledge',
        detail: '/activity-phase/api/knowledge/',
        favorite: '/activity-phase/api/knowledge/favorite/',
        like: '/activity-phase/api/knowledge/like/',
        part: '/activity-phase/api/knowledge/part'
    },

    config: {},

    // 公益专区
    public: {
        home: '/community/api/homepage',
        action: '/community/api/content', // 公益行动
        list: '/community/api/love/collection', // 爱心集市列表
        detail: '/community/api/love/collection/', // 爱心集市详情
        message: '/community/api/messages', // 获取滚动消息
        icon: '/community/api/baseconfig/icon', // 获取icon列表
        ad: '/community/api/advertising/', // 点击广告
        td_record: '/community/api/donate/', // 通道打点
        content_record: '/community/api/content/' // 通道打点
    },

    // 抗癌百科
    anticancer: {
        channelList: '/encyclopedia-phase/api/encyclopedia_channel',
        channelPost: '/encyclopedia-phase/api/encyclopedia_channel/user',
        channelContent: '/encyclopedia-phase/api/encyclopedia_channel/content',
        // 科普手册
        manualList: '/encyclopedia-phase/api/encyclopedia_manual',
        curriculumList: '/encyclopedia-phase/api/encyclopedia_anticancer',
        // 抗癌百科banner的数据
        Banner: '/course-phase/api/banner/list',
        // 专家详情
        professor: '/encyclopedia-phase/api/professor'
    },

    // 固定链接
    url: {
        // 捐赠通道链接
        donation_channel_url: 'http://lxi.me/fae6h',
        // 献爱心链接
        show_love_url: 'http://lxi.me/xno6a',
        // 加入志愿者链接
        join_volunteer: 'http://lxi.me/r054h',
        // 联系我们
        contact_me: 'https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8'
    },
    // 医疗服务
    medical: {
        list: '/course-phase/api/medical/service',
        detail: '/course-phase/api/medical/service/',
        invite: '/course-phase/api/medical/appointment'
    },
    subject: {
        index: '/encyclopedia-phase/api/subject/'
    },
    gb_proxy:{
        baseinfo:'/wechat-phase/gb-proxy/get-pat-basics-info',
        disease:'/wechat-phase/gb-proxy/get-pat-disease-info',
        history:'/wechat-phase/gb-proxy/get-pat-history-diag-list',
        visit:'/wechat-phase/gb-proxy/get-pat-visit-info',
        consul:'/wechat-phase/gb-proxy/get-pat-consult-list',
        agent:'/wechat-phase/get-workjs-agentconfig',
    },

    // 获得数据
    getData: function(type, url, params) {
        var that = this
        var token = localStorage.getItem('access_token')
        let axios
        if ('get' == type) {
            axios = AxiosSND.get(url, {
                params: params
            })
        } else if ('post' == type) {
            axios = AxiosSND.post(url, qs.stringify(params))
        } else if ('postJson' == type) {
            axios = AxiosSND.post(url, params)
        } else if ('put' == type) {
            axios = AxiosSND.put(url, qs.stringify(params))
        } else if ('put' == type) {
            axios = AxiosSND.put(url, qs.stringify(params))
        } else if ('delete' == type) {
            axios = AxiosSND.delete(url, qs.stringify(params))
        }

        let promise = new Promise((resolve, reject) => {
            axios
                .then(response => {
                    if (200 == response.status) {
                        resolve(response.data)
                    } else if (403 == response.status) {
                        Vue.prototype.$message.error('未知错误！')
                    } else if (500 == response.status) {
                        Vue.prototype.$message.error('未知错误！')
                    } else if (422 == response.status) {
                        console.log(response, 422)
                    } else {
                        Vue.prototype.$message.error('未知错误！')
                    }
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        Vue.prototype.$message.error('登录超时，请重新登录！')
                        // router.push('/login')
                    } else if (error.request) {
                        if (error.request.status == 422 && error.request.response.indexOf('name') != -1) {
                            Vue.prototype.$message.error('项目名称已存在！')
                        } else {
                            Vue.prototype.$message.error('网络异常，请检查您的网络并刷新重试！')
                        }
                    } else {
                        Vue.prototype.$message.error('未知错误，请刷新重试！')
                    }
                })
        })
        return promise
    },

    //时间戳，在需要时间转换的时候可以直接调用
    getTime: function(time) {
        var newDate = new Date()
        newDate.setTime(time * 1000)
        Date.prototype.format = function(format) {
            var date = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes()
            }
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in date) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length)
                    )
                }
            }
            return format
        }
        return newDate.format('yyyy-MM-dd hh:mm')
    },
    //时间戳，在需要时间转换的时候可以直接调用 'yyyy-MM-dd hh:mm:ss'
    getSeconds: function(time, formatType = 'yyyy-MM-dd hh:mm') {
        var newDate = new Date()
        newDate.setTime(time * 1000)
        Date.prototype.format = function(format) {
            var date = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes(),
                's+': this.getSeconds()
            }
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in date) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length)
                    )
                }
            }
            return format
        }
        return newDate.format(formatType)
    },
    getDateTime: function(time, formatType) {
        var newDate = new Date()
        newDate.setTime(time * 1000)
        Date.prototype.format = function(format) {
            var date = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes()
            }
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in date) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(
                        RegExp.$1,
                        RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length)
                    )
                }
            }
            return format
        }
        let formatStr = formatType ? formatType : 'yyyy-MM-dd'
        return newDate.format(formatStr)
    },
    GetQueryUrl: name => {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = window.location.search.substr(1).match(reg)
        if (r != null) {
            return unescape(r[2])
        } else {
            return ''
        }
    },
    setCookie: function(name, val, days) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + days)
        document.cookie = name + '=' + escape(val) + (days == null ? '' : ';expires=' + exdate.toGMTString())
    },
    getCookie: function(c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + '=')
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1
                var c_end = document.cookie.indexOf(';', c_start)
                if (c_end == -1) c_end = document.cookie.length
                return unescape(document.cookie.substring(c_start, c_end))
            }
        }
        return ''
    },
    deleteRepetionChar: function(arr) {
        //先判断输入进来的是数组对象还是字符串
        if (typeof arr == 'object') {
            var arr = arr
        } else if (typeof arr == 'string') {
            //字符串转为数组
            var arr = arr.split(',')
        }
        //存放不相同的数据
        var box = [] //存放去重数据
        var thisArr //当前的值arr[i]
        //遍历数组
        for (var i = 0; i < arr.length; i++) {
            thisArr = arr[i]
            //定义一个旗子，检查是不是有重复的字符
            var flag = true
            //遍历存放数据盒子，检查是否等于当前元素
            for (var j = 0; j < box.length; j++) {
                //如果值存在
                if (box[j] == thisArr) {
                    flag = false
                    break //结束for循环
                }
            }
            if (flag == false) {
                //continue返回执行函数而不压入数组
                continue
            }
            box.push(thisArr)
        }
        return box
    },
    cloneObj: function(obj) {
        let str,
            newobj = obj.constructor === Array ? [] : {}
        if (typeof obj !== 'object') {
            return
        } else if (window.JSON) {
            ;(str = JSON.stringify(obj)), //系列化对象
                (newobj = JSON.parse(str)) //还原
        } else {
            for (let i in obj) {
                newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i]
            }
        }
        return newobj
    },
    destroy: function(url, callback) {
        Vue.prototype
            .$confirm('确认删除吗', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
            .then(() => {
                let params = {
                    _method: 'delete'
                }
                this.getData('post', url, params).then(res => {
                    if (res.data.code == 200) {
                        Vue.prototype.$message.success('删除成功')
                        callback(res.data.code)
                    } else {
                        Vue.prototype.$message.error(res.data.message)
                    }
                })
            })
    },
     isWeChat() {
        // 获取浏览器的 userAgent 字符串
        const ua = navigator.userAgent.toLowerCase();
        // 判断是否为微信环境
        return ua.indexOf('micromessenger') > -1;
    },

     isWorkWeChat() {
        // 获取浏览器的 userAgent 字符串
        const ua = navigator.userAgent.toLowerCase();
        // 判断是否为企业微信环境
        return ua.indexOf('wxwork') > -1;
    },
    getShareInfo(_this, title="", img="", desc="", type, id, uri, debug = false) {

        let Interface = this
        debug = false
        let url = window.location.href
        var params = {
            uri: encodeURI(url)
        }
        title = title === '' ? '博医同行' : title
        this.setDocumentTitle(title)
        desc = desc == '' || desc == '<p><br></p>' || desc == 'null' ? '点击查看更多' : desc
        if (!desc) {
            desc = '点击查看更多'
        }
        if (!img || img == '') {
            img = Interface.host + '/static/bytx/share_logo.png'
        }
        if(this.isWorkWeChat()){
            return false
        }
        Interface.getData('get', Interface.wechat_share,params).then(res => {
            // 调用函数进行判断
            wx.config({
                debug: debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.app_id, // 必填，公众号的唯一标识，填自己的！
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'chooseImage',
                    'previewImage',
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                ],
                openTagList: ['wx-open-launch-weapp']
            })

            wx.ready(() => {

                // this.getQwConf()
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: img, // 分享图标
                    success: function() {
                        console.log('updateAppMessageShareData=====')
                        // _this.shareFootPrint(title,type,id)
                    },
                    fail(...args) {
                        console.log('fail', args)
                    },
                })

                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: img, // 分享图标
                    success: function() {
                        // 设置成功
                        // _this.shareFootPrint(title,type,id)
                        console.log('updateTimelineShareData=====')
                    },
                    fail(...args) {
                        console.log('fail', args)
                    },
                })
                //转发到朋友圈
                wx.onMenuShareTimeline({
                    title: title, // 转发时的标题
                    link: url, // 转发时的链接
                    imgUrl: img, // 转发时的图标
                    success: function() {
                        // _this.shareFootPrint(title,type,id)
                        console.log('onMenuShareTimeline=====')
                    },
                    fail(...args) {
                        console.log('fail', args)
                    },
                    cancel: function() {}
                })

                //转发给朋友
                wx.onMenuShareAppMessage({
                    title: title,
                    desc: desc,
                    link: url,
                    imgUrl: img,
                    type: '',
                    dataUrl: '',
                    success: function() {
                        // _this.shareFootPrint(title,type,id)
                        console.log('onMenuShareAppMessage=====')
                    },
                    fail(...args) {
                        console.log('fail', args)
                    },
                    cancel: function() {}
                })
            })
        })
    },

    getSignUrl: function() {
        var signLink = ''
        var ua = navigator.userAgent.toLowerCase()
        if (/iphone|ipad|ipod/.test(ua)) {
            signLink = sessionStorage.getItem('WxCodeUrl')
            if (!signLink) signLink = location.href
        } else {
            signLink = location.href
        }
        return signLink
    },
    logout() {
        let Interface = this
        let url = window.location.href
        Interface.getData('get', Interface.wechat_share, {
            uri: encodeURI(url)
        }).then(res => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.app_id, // 必填，公众号的唯一标识，填自己的！
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: ['closeWindow']
            })

            wx.ready(function() {
                //转发到朋友圈
                wx.closeWindow()
            })
        })
    },
    setDocumentTitle(title) {
        document.title = title
        if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
            var i = document.createElement('iframe')
            i.src = 'https://bytx.care-gobroad.com/static/bytx/home_head_1_icon.svg'
            i.style.display = 'none'
            i.onload = function() {
                i.remove()
            }
            document.body.appendChild(i)
        }
        window.history.replaceState({}, document.title, location.href)
    },
    footPrint(type, id = 0, content_type = 0, note = '') {
        let params = {
            id: id,
            type: type,
            content_type: content_type,
            note: note == '' ? Types[type] : note
        }
        this.getData('post', this.footprint, params)
    },
    footPrint1(type, id = 0 ) {
        let params = {
            id: id,
            type: type
        }
        this.getData('post', this.footprint, params)
    },
    listShareInfo(_this, type) {
        switch (type) {
            case 1:
                this.footPrint(60, 1, 0, '浏览公益专区首页')
                break
            case 2:
                this.footPrint(56, 1, 0, '浏览公益救助列表')
                break
            case 3:
                this.footPrint(57, 1, 0, '浏览公益行动列表')
                break
            case 4:
                this.footPrint(58, 1, 0, '浏览爱心集市列表')
                break
            case 5:
                this.footPrint(59, 1, 0, '浏览病友故事列表')
                break
        }
        this.getData('get', this.community.share_info + type).then(res => {
            this.getShareInfo(_this, res.data.title, res.data.logo, res.data.desc)
        })
    },
    goLink(href) {
        href = href.replace('https://bytx.care-gobroad.com', '')
        href = href.replace('https://bytx.care-gobroad.com', '')
        LocationHref(href)
    },
    goArticle(_this,id, type) {
        if (type === 2) {
            _this.$router.push({ name: 'article-column', params: { id: id } })
        } else {
            _this.$router.push({ name: 'article-detail', params: { id: id } })
        }
    },
    goVideo(_this,id, type) {
        if (type === 2) {
            _this.$router.push({ name: 'video-column', params: { id: id } })
        } else {
            _this.$router.push({ name: 'video-detail', params: { id: id } })
        }
    },
    goLive(_this,id, type, live_status) {
        if (type === 2) {
            _this.$router.push({ name: 'live-column', params: { id: id } })
        } else if (live_status === 6) {
            _this.$router.push({ name: 'live-detail-home', params: { id: id } })
        } else {
            if (live_status === 0) {
                _this.$router.push({ name: 'live-detail', params: { id: id } })
            } else {
                _this.$router.push({ name: 'live-detail-home', params: { id: id } })
            }
        }
    },
    goDotor(id, type) {
        if (type === 2) {
            this.$router.push({ name: 'doctor-details', params: { id: id } })
        }
    },
    goProfessor(_this,id) {
        _this.$router.push({ name: 'doctor-details', params: { id: id } })
    },
    goClinic(_this,id) {
        _this.$router.push({name:'clinic-detail',params:{'id':id}})
    },
    goMedicalAssistance(_this,id){
        if(id > 46){
            _this.$router.push({
                name : 'community-detail-new',
                params : {
                    id : id
                }
            })
        }else{
            _this.$router.push({
                name : 'community-detail',
                params : {
                    id : id
                }
            })
        }
    },
    goAudio(_this,id, type) {
        return false
    },
    goTopic(_this,id){
        this.footPrint1(16, id)
        _this.$router.push({name:'topic-detail',params:{'id':id}})
        window.location.reload()
    },
    mFootPrint( id = 0, type,content_type = 0,page_type, source_type = 0, parent_id = 0, record_id = 0, title, extend_title = '') {
      let params = {
        id: id,
        type: type,
        content_type: content_type,
        page_type: page_type,
        source_type: source_type,
        parent_id: parent_id,
        record_id: record_id,
        title: title,
        extend_title: extend_title
      }
      this.getData('post', this.footprint, params)
    },
    shareFootPrint(title,type,id){
      if (type == 19) {
        this.mShareFootPrint(19,1,1, '首页')
      } else if (type == 90) {
        this.mShareFootPrint(90,1,1, '抗癌百科')
      } else if (type == 70) {
          this.mShareFootPrint(70,1,1, '医疗服务')
      } else if (type == 98) {
          this.mShareFootPrint(98,1,1, '疾病库')
      } else if (type == 101) {
          this.mShareFootPrint(101,1,1, '抗癌公开课')
      }
    },
    mShareFootPrint(type,source_type,content_id,title) {
      let params = {
        type: type,
        source_type: source_type,
        content_id: content_id,
        title: title
      }
      this.getData('post', this.shareFootPrintUrl, params)
    },
    getUrl(url) {
      let source_type = 0
      if (url && url.indexOf('?') > -1) {
        let params = url.split('?')[1]
        if (params) {
          let arr = params.split('&')
          for(let i = 0; i < arr.length; i++) {
            let p = arr[i].split('=')
            if (p[0] == 'source_type') {
              source_type = p[1]
            }
          }
        }
      }
      return source_type
    },
    // 曝光打点
    exposureFootPrint(data) {
        let params = { data: data }
        this.getData('post',this.exposureFootPrintUrl, params)
    },
    // 曝光打点
    pvPrint(id) {
      if(id == 0){
        setTimeout(() => {
          this.getData('post',this.pvPrintUrl, {
            id:id,
            title:document.title,
            path:window.location.href
          }).then(res => {
            if(res.code == 0){
              sessionStorage.setItem('PvLastId', res.data.id)
            }
          })
        },1000)
      }else{
        this.getData('post',this.pvPrintUrl, {id:id,})
        setTimeout(() => {
          this.getData('post',this.pvPrintUrl, {
            id:0,
            title:document.title,
            path:window.location.href
          }).then(res => {
            if(res.code == 0){
              sessionStorage.setItem('PvLastId', res.data.id)
            }
          })
        },1000)
      }
    },
    CoFootPrint(cate) {
        let remark = ""
        // 分类:1:注册,2:认证,3:医疗服务,4:临床招募,5:公益救助,6:首页,7:看直播,8:交流社区,
        // 9:首页金刚位,10:抗癌百科首页,11:医疗服务首页,12:公益救助首页,13:疾病库页,14:抗癌公开课页,
        // 15:科普手册页,16:临床招募列表,17:救助项目列表
        // 18:咨询专家,19:线上开药,20:专家推荐 ,21:医疗服务banner
        // 22: 临床招募,23:预约门诊,24:远程会诊,25:就诊指南,26:基因检查
        switch (cate) {
            case 6:
                remark ="访问了首页"
                break;
            case 7:
                remark ="访问了看直播"
                break;
            case 8:
                remark ="访问了交流社区"
                break;
            case 9:
                remark ="访问了首页金刚位"
                break;
            case 10:
                remark ="访问了抗癌百科首页"
                break;
            case 11:
                remark ="访问了医疗服务首页"
                break;
            case 12:
                remark ="访问了公益救助首页"
                break;
            case 13:
                remark ="访问了疾病库页"
                break;
            case 14:
                remark ="访问了抗癌公开课页"
                break;
            case 15:
                remark ="访问了科普手册页"
                break;
            case 16:
                remark ="访问了临床招募列表"
                break;
            case 17:
                remark ="访问了救助项目列表"
                break;
            case 18:
                remark ="点击了医疗服务咨询专家"
                break;
            case 19:
                remark ="点击了医疗服务线上开药"
                break;
            case 20:
                remark ="点击了医疗服务专家推荐"
                break;
            case 21:
                remark ="点击了医疗服务医疗服务banner"
                break;
            case 22:
                remark ="点击了医疗服务临床招募"
                break;
            case 23:
                remark ="点击了医疗服务预约门诊"
                break;
            case 24:
                remark ="点击了医疗服务远程会诊"
                break;
            case 25:
                remark ="点击了医疗服务就诊指南"
                break;
            case 26:
                remark ="点击了医疗服务基因检查"
                break;
        }
        let params = {
            cate: cate,
            remark: remark
        }
        this.getData('post',this.corecord, params)
    }
}



// WEBPACK FOOTER //
// ./src/util/interface.js